/* =================== CUSTOM SLIDER (VANILLA JS) =================== */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    const slider = document.getElementById("custom-slider");
    if (!slider) return;

    const slides = slider.querySelectorAll(".custom-slide");
    const prevBtn = slider.querySelector(".custom-slider-arrow.prev");
    const nextBtn = slider.querySelector(".custom-slider-arrow.next");
    const dots = slider.querySelectorAll(".custom-slider-dot");

    let currentIndex = 0;
    let autoplayInterval = null;
    const intervalTime = 5000;

    // Inicializa as imagens responsivas
    function adjustResponsiveBackgrounds() {
      const isMobile = window.innerWidth <= 768;
      slides.forEach((slide) => {
        const mbBg = slide.getAttribute("data-background-mobile");
        if (isMobile && mbBg) {
          slide.style.backgroundImage = `url('${mbBg}')`;
        } else {
          // Volta para o desktop background se foi alterado ou usa o default
          const deskBg = slide.getAttribute("style").match(/url\(['"]?([^'"]+)['"]?\)/);
          if (deskBg && deskBg[1]) {
            slide.style.backgroundImage = `url('${deskBg[1]}')`;
          }
        }
      });
    }

    // Altera o slide ativo
    function goToSlide(index) {
      // Garante limites circulares
      if (index < 0) {
        index = slides.length - 1;
      } else if (index >= slides.length) {
        index = 0;
      }

      // Remove classes ativas de todos
      slides.forEach((slide) => slide.classList.remove("active"));
      dots.forEach((dot) => dot.classList.remove("active"));

      // Adiciona no slide selecionado
      currentIndex = index;
      slides[currentIndex].classList.add("active");
      if (dots[currentIndex]) {
        dots[currentIndex].classList.add("active");
      }
    }

    // Próximo e anterior
    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    function prevSlide() {
      goToSlide(currentIndex - 1);
    }

    // Inicia autoplay
    function startAutoplay() {
      stopAutoplay();
      autoplayInterval = setInterval(nextSlide, intervalTime);
    }

    // Para autoplay
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    // Eventos de controles
    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        prevSlide();
        startAutoplay(); // Reinicia temporizador
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        nextSlide();
        startAutoplay(); // Reinicia temporizador
      });
    }

    // Eventos de dots
    dots.forEach((dot) => {
      dot.addEventListener("click", function () {
        const slideIndex = parseInt(this.getAttribute("data-slide"));
        goToSlide(slideIndex);
        startAutoplay(); // Reinicia temporizador
      });
    });

    // Pause on Hover
    slider.addEventListener("mouseenter", stopAutoplay);
    slider.addEventListener("mouseleave", startAutoplay);

    // Ajusta backgrounds no load e resize
    adjustResponsiveBackgrounds();
    window.addEventListener("resize", adjustResponsiveBackgrounds);

    // Inicia tudo
    goToSlide(0);
    startAutoplay();
  });
})();
